// TODO: move other zoomHelpers in here
export const addHoursAndMinutesInMs = (startTimeInMs, hours, minutes) => {
  return startTimeInMs + 1000 * 3600 * hours + 1000 * 60 * minutes;
};